import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'partial-menu-ajuda',
  templateUrl: './menu-ajuda.component.html',
  styleUrls: ['./menu-ajuda.component.scss']
})
export class MenuAjudaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
